import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AdvanceValueLessThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.advance-value.less-than-zero');
    }
}
